import { computed } from 'vue';
import { useProduct } from '~/modules/product/composables/useProduct';
import { useAvailability as useAvailabilityMCL } from '@nuxt-common/media-card-large/app/composables/useAvailability';
import { useProductType } from '~/composables/useProductType';
import useLatchkey from '~/modules/latchkey/composables/useLatchkey';
import { toTraitId } from '~/modules/latchkey/utils/utils';
import useFeatureEligibility from '~/modules/featureControl/composables/useFeatureEligibility';
import useSelectedMemberId from '~/modules/latchkey/composables/useSelectedMemberId';

export default function useAvailability() {
  const { productId } = useProduct();
  const { isConsolidatedLatchKey, isShopTheSet } = useProductType();
  const { isShopTheSetExpEnabled } = useFeatureEligibility();

  if (isConsolidatedLatchKey) {
    const { selectedLatchkey } = useLatchkey();
    const traitId = computed(() => toTraitId(productId, selectedLatchkey.value));
    const result = useAvailabilityMCL(traitId);
    return {
      isColorAvailable: computed(() => result.isColorAvailable),
      isSizeAvailable: computed(() => result.isSizeAvailable),
    };
  }

  if (isShopTheSetExpEnabled && isShopTheSet) {
    const selectedMember = useSelectedMemberId();
    return useAvailabilityMCL(selectedMember);
  }

  return useAvailabilityMCL(productId);
}
